import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AdminLayout from './AdminLayout';
import { getAdminBooksApi, deleteBookApi } from '../../utils/api';

const S = process.env.REACT_APP_API_URL?.replace('/api','') || '';

export default function AdminBooks() {
  const [books, setBooks]   = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => { setLoading(true); getAdminBooksApi().then(({data})=>setBooks(data)).finally(()=>setLoading(false)); };
  useEffect(load, []);

  const del = async (id,title) => {
    if (!window.confirm(`Delete "${title}" and all its chapters?`)) return;
    await deleteBookApi(id);
    setBooks(b=>b.filter(x=>x._id!==id));
  };

  return (
    <AdminLayout title="Manage Books">
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
        <span style={{ color:'var(--text3)', fontSize:'0.88rem' }}>{books.length} books</span>
        <Link to="/admin/books/new" className="btn btn-gold btn-sm">+ Add Book</Link>
      </div>

      {loading ? <div className="spinner"/> : (
        <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--radius-lg)', overflow:'hidden' }}>
          <div style={{ display:'grid', gridTemplateColumns:'2.5fr 1fr 0.8fr 0.7fr 1fr 1.8fr', padding:'12px 20px', background:'var(--bg2)', fontWeight:700, fontSize:'0.72rem', color:'var(--text3)', textTransform:'uppercase', letterSpacing:'0.08em', gap:12 }}>
            <span>Book</span><span>Genre</span><span>Price</span><span>Ch.</span><span>Status</span><span>Actions</span>
          </div>
          {books.length===0 && <div style={{padding:'40px',textAlign:'center',color:'var(--text3)'}}>No books yet. <Link to="/admin/books/new" style={{color:'var(--gold)'}}>Add one →</Link></div>}
          {books.map(book => {
            const cover = book.coverImage ? (book.coverImage.startsWith('http')?book.coverImage:`${S}${book.coverImage}`) : null;
            return (
              <div key={book._id} style={{ display:'grid', gridTemplateColumns:'2.5fr 1fr 0.8fr 0.7fr 1fr 1.8fr', padding:'14px 20px', borderTop:'1px solid var(--border)', alignItems:'center', gap:12 }}>
                <div style={{display:'flex',gap:12,alignItems:'center'}}>
                  {cover ? <img src={cover} alt="" style={{width:36,height:50,objectFit:'cover',borderRadius:4,flexShrink:0}}/>
                    : <div style={{width:36,height:50,background:'var(--bg3)',borderRadius:4,display:'flex',alignItems:'center',justifyContent:'center',fontSize:'1.1rem',flexShrink:0}}>📚</div>}
                  <div>
                    <p style={{fontWeight:700,color:'var(--text)',fontSize:'0.88rem',lineHeight:1.3}}>{book.title}</p>
                    <p style={{color:'var(--text3)',fontSize:'0.75rem'}}>by {book.author||'Admin'}</p>
                  </div>
                </div>
                <span className="badge badge-amber">{book.genre}</span>
                <span style={{fontWeight:700,color:book.price===0?'var(--success)':'var(--gold)'}}>{book.price===0?'Free':`₹${book.price}`}</span>
                <span style={{color:'var(--text2)'}}>{(book.chapters||[]).length}</span>
                <span className={`badge badge-${book.published?'free':'locked'}`}>{book.published?'Live':'Draft'}</span>
                <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
                  <Link to={`/admin/books/${book._id}/chapters`} className="btn btn-ghost btn-sm">Chapters</Link>
                  <Link to={`/admin/books/${book._id}/edit`} className="btn btn-dark btn-sm">Edit</Link>
                  <button className="btn btn-danger btn-sm" onClick={()=>del(book._id,book.title)}>Del</button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </AdminLayout>
  );
}
